// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"info-block_wrapper__9Y_Jc"};